import { Component, Input } from '@angular/core';
import { CommonModule, DatePipe, DecimalPipe, NgIf } from '@angular/common';
import { LabelComponent } from '../../../../../../../../common/label/label.component';
import {
  ParcelsPreviewComponent
} from '../../../../../common/components/parcels/parcels-preview/parcels-preview.component';
import {
  LocationOfDevicesUnrelatedToRoadOccupationFormValue
} from '../../forms/location-of-devices-unrelated-to-road-occupation.form';
import { ToNumberPipe } from '../../../../../../../../pipes/to-number.pipe';
import {
  LocationDecisionsPreviewComponent
} from '../../../../../common/components/location-decisions/location-decisions-preview/location-decisions-preview.component';

@Component({
  selector: 'app-location-of-devices-unrelated-to-road-occupation-preview',
  standalone: true,
  imports: [
    DatePipe,
    LabelComponent,
    ParcelsPreviewComponent,
    DecimalPipe,
    CommonModule,
    ToNumberPipe,
    LocationDecisionsPreviewComponent
  ],
  templateUrl: './location-of-devices-unrelated-to-road-occupation-preview.component.html'
})
export class LocationOfDevicesUnrelatedToRoadOccupationPreviewComponent {
  @Input()
  public occupation: LocationOfDevicesUnrelatedToRoadOccupationFormValue | undefined;
}
